import { render } from "./process_id_by_mother.vue?vue&type=template&id=5d6c439f&scoped=true"
import script from "./process_id_by_mother.vue?vue&type=script&lang=js"
export * from "./process_id_by_mother.vue?vue&type=script&lang=js"

import "./process_id_by_mother.vue?vue&type=style&index=0&id=5d6c439f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d6c439f"]])

export default __exports__